<template>
  <span
    v-if="small"
    class="text-primary cursor-pointer text-body-1 font-italic font-weight-bold"
    @click="openPromotionalLink"
  >
    {{ $t('b2bCommerPowered') }}
  </span>
  <div
    v-else
    class="background pa-1 pa-md-2 pa-xl-3 rounded-ts-xl position-fixed bottom-0 right-0 text-right"
  >
    <span
      class="text-white cursor-pointer text-decoration-none text-h6 text-sm-h5 text-md-h4 text-lg-h3 font-weight-bold font-italic"
      @click="openPromotionalLink"
    >
      {{ $t('b2bCommerPowered') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { B2B_COMMERCE_PROMOTIONAL_LINK } from '@/types'

defineProps({
  small: {
    type: Boolean,
    default: false
  }
})

const openPromotionalLink = () => {
  window.open(B2B_COMMERCE_PROMOTIONAL_LINK, '_blank')
}
</script>

<style lang="scss" scoped>
.background {
  background-color: #04192d;
}
</style>
